<template>
    <div class="fixed-center text-center">
        <q-icon name="fas fa-exclamation-circle" size="lg" color="warning" />

        <h6 class="text-faded q-mt-md">
            {{
                $t(
                    "The application encountered an error. Please reload the application by clicking the button. If the problem persists, contact support at support{'@'}iotorq-lean.com." // eslint-disable-line
                )
            }}
        </h6>
        <div v-if="code" class="q-mt-md q-mb-lg text-grey">
            {{ $t('Error: {code}', { code: code }) }}
        </div>
        <div class="row wrap justify-evenly q-gutter-md">
            <q-btn
                color="secondary"
                style="width: 200px"
                @click="reload"
                :label="$t('Reload')"
            />
            <a
                href="mailto:support@iotorq-lean.com?"
                style="text-decoration: none"
            >
                <q-btn
                    color="secondary"
                    style="width: 200px"
                    :label="$t('Report an issue')"
                >
                </q-btn>
            </a>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'pinia';
import { useAuthStore } from '@stores/auth';
export default {
    name: 'ErrorPage',
    methods: {
        ...mapActions(useAuthStore, ['logoutAction']),
        reload() {
            // Clear all state and reload the page
            this.logoutAction();
            this.$router.push({ name: 'login' });
        }
    },
    computed: {
        /**
         * Get the error code from the history state
         * @returns {string} - The error code
         */
        code() {
            return history.state.code;
        }
    }
};
</script>
